import anime from 'animejs/lib/anime.es.js';
import gsap from 'gsap';
import ScrollTrigger from 'ScrollTrigger';

export default class Header {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);

		this.init();
	}

	init() {
		Header.prototype.isSticky = false;
	}

	animateHeader() {
		console.log('isSticky??', Header.prototype.isSticky);

		if (Header.prototype.isSticky) {
			this.showSticky();
		} else {
			this.hideSticky();
		}
	}

	toggleMenu() {
		jQuery('body').toggleClass('animate');
	}

	showSticky() {
		const topHeight = jQuery('.header__top').height();

		let tl = gsap
			.timeline()
			.to('.header__title', { opacity: 0, duration: 0.1 })
			.to('.long', {
				opacity: 0,
				x: '-2rem',
				duration: 0.2,
				onComplete: function() {
					jQuery('.header__logo .long').html('P M');
				},
			})
			.to('.long', { opacity: 1, x: '0', duration: 0.1 });
	}

	hideSticky() {
		let tl = gsap
			.timeline()
			.to('.long', {
				opacity: 1,
				duration: 0.25,
				onStart: function() {
					jQuery('.header__logo .long').text(siteTitle);
				},
			})
			.to('.header__title', { opacity: 1, duration: 0.1 });
	}
}
